/*
 * SUBMIT FORM NEWSLETTER
 */
$('#formNewsletter').submit(function (e) {
    e.preventDefault();

    var form = $(this);

    form.ajaxSubmit({
        url: url("/newsletter"),
        type: "post",
        dataType: "json",
        beforeSend: function () {
            loaderShow();
        },
        success: function (response) {

            setTimeout(() => {

                loaderClose();

                if (response.message) {
                    Swal.fire({
                        title: "Ops...",
                        icon: "error",
                    });
                }

                if (response.success) {
                    Swal.fire({
                        title: "Cadastrado com sucesso!",
                        icon: "success",
                        showConfirmButton: false,
                        timer: 2000,
                    });

                    $("#formNewsletter")[0].reset();
                }

            }, 500);

        }
    })

});